const merge = (editor, firstUL, secondUL) => {
  let index = firstUL.nodes.toArray().length;
  const childrenOfSecondUL = secondUL.nodes.toArray();
  childrenOfSecondUL.forEach((item) => {
    editor.moveNodeByKey(item.key, firstUL.key, index);
    index += 1;
  });
};

export default (editor) => {
  let tempkey = editor.value.focusBlock.key;
  while (
    editor.value.document.getParent(tempkey).type === 'list_item' ||
    editor.value.document.getParent(tempkey).type === 'unordered_list'
  ) {
    tempkey = editor.value.document.getParent(tempkey).key;
  }
  const editableDivNode = editor.value.document.getParent(tempkey);
  const children = editableDivNode.nodes.toArray();
  let previousChild = null;
  for (let i = 0; i < children.length; i += 1) {
    if (
      previousChild &&
      children[i].type === 'unordered_list' &&
      previousChild.type === 'unordered_list'
    ) {
      merge(editor, previousChild, children[i]);
      return true;
    }
    previousChild = children[i];
  }
  return true;
};
